import(/* webpackMode: "eager" */ "/usr/src/app/src/app/global-error.tsx");
